import { HolderOutlined } from '@ant-design/icons';

import { RedirectIcon } from 'app/components/pages/Hotels/RedirectIcon';

import styles from '../../PackagesRoomsAmenities.module.scss';

import { EntityActionsMenu } from './EntityActionsMenu';
import { EntityStatusBadge } from './EntityStatusBadge';
import type { EntityRowConfig } from './entity';

type Props = {
  config: EntityRowConfig;
  handleRef?: (node: HTMLElement | null) => void;
  dragHandleProps?: React.HTMLAttributes<HTMLElement> & {
    handleRef?: (node: HTMLElement | null) => void;
  };
  tableType: 'package' | 'room' | 'activity';
  isDraggable?: boolean;
};

export const EntityRow = ({
  config,
  handleRef,
  dragHandleProps,
  tableType,
  isDraggable = false,
}: Props) => {
  const {
    cover,
    primaryLabel,
    secondaryLabel,
    status,
    redirectPath,
    actions,
    pkgUserLabel,
    roomCapacityLabel,
  } = config;

  const { handleRef: handleRefFromDragProps, ...safeDragHandleProps } =
    dragHandleProps ?? {};

  const resolvedHandleRef = handleRef ?? handleRefFromDragProps;

  return (
    <div className={styles.itemWrapper}>
      <div className={styles.item}>
        <div className={styles[`${tableType}Row`]}>
          {cover && primaryLabel && (
            <div className={styles.itemLeft}>
              <div className={styles.cover}>{cover}</div>
              <div className={styles.itemLabels}>
                <span className={styles.primaryLabel}>{primaryLabel}</span>
                {secondaryLabel && (
                  <span className={styles.secondaryLabel}>
                    {secondaryLabel}
                  </span>
                )}
              </div>
            </div>
          )}

          {pkgUserLabel !== undefined && (
            <div className={styles.pkgUserLabel}>
              <span>{pkgUserLabel}</span>
            </div>
          )}

          {roomCapacityLabel !== undefined && (
            <div className={styles.roomCapacityLabel}>
              <span>{roomCapacityLabel}</span>
            </div>
          )}

          <div className={styles.statusActions}>
            <EntityStatusBadge status={status} />
            <EntityActionsMenu actions={actions} />
          </div>

          {redirectPath && (
            <a
              className={styles.redirect}
              href={redirectPath}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              <RedirectIcon />
            </a>
          )}

          {isDraggable && (
            <div
              className={styles.dragHandle}
              ref={resolvedHandleRef}
              {...safeDragHandleProps}
              onClick={(e) => e.stopPropagation()}
            >
              <HolderOutlined />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
